import { useQuery } from "react-query";
import { fetchFile, fetchFileContent } from "../mutations/file.mutations";

export const useFileContent = ({ id }: { id: number | string | undefined }) => {
	return useQuery(
		["files", "download", id],
		async () => {
			return fetchFileContent(id);
		},
		{
			enabled: id !== undefined,
			retry: false,
		},
	);
};

export const useFile = ({ id }: { id: number | string | undefined | null }) => {
	return useQuery(
		["files", id],
		async () => {
			return fetchFile(id);
		},
		{
			enabled: id !== undefined && id !== null,
			retry: false,
		},
	);
};
